import { inject } from "@angular/core";
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { RESPONSE } from "src/express.tokens";
import { IS_BROWSER_TOKEN } from "../tokens/is-browser.token";
import { Response } from "express";
import { TranslateService } from "@ngx-translate/core";
import { navigateCrossPlatform } from "src/app/util";
import { ServerConfigService } from "../service/server-config.service";
import { LoggerService } from "../service/logger.service";

export const sitePathLangGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router: Router = inject(Router);
    const isBrowser: boolean = inject(IS_BROWSER_TOKEN);
    const translate: TranslateService = inject(TranslateService);
    const response: Response|null = inject(RESPONSE, { optional: true });
    const serverConfigService: ServerConfigService = inject(ServerConfigService);
    const loggerService: LoggerService = inject(LoggerService);

    // 所有語系
    let langs: string[] = [];
    // 預設語系
    let defaultLang: string;
    //  網址中的語系
    let lang: string = route.params['lang'];
    //  網址中的路徑
    let path: string|null = route.params['path'];

    // 根據 API 給的組出來 langs 和 defaultLang
    langs = ['zh-tw', 'en-us'];
    defaultLang = 'zh-tw';

    if (!langs.length) {
      const redirectPaths = [`${isBrowser ? '/' : serverConfigService.baseHref}404`];
      loggerService.error(`請確認有語系資料，轉導至${redirectPaths.join('/')}`);
      navigateCrossPlatform(isBrowser, router, response, redirectPaths);
      return false;
    }

    // 設定i18n
    translate.addLangs(langs);
    translate.setDefaultLang(defaultLang);

    if (!lang) {
      const redirectPaths = [`${isBrowser ? '/' : serverConfigService.baseHref}${path}`, defaultLang];
      loggerService.info(`無路徑語系，轉導至預設語系${redirectPaths.join('/')}`);
      navigateCrossPlatform(isBrowser, router, response, redirectPaths);
      return false;
    } else if (langs.findIndex((v) => v === lang) > -1) {
      // 有路徑語系，且也在語系列表中
      translate.use(lang);
      serverConfigService.config.lang = lang;
      return true;
    } else {
      const redirectPaths = [`${isBrowser ? '/' : serverConfigService.baseHref}${path}`, defaultLang];
      loggerService.info(`有路徑語系(${lang})，但是不在語系列表中，轉導至預設語系${redirectPaths.join('/')}`);
      navigateCrossPlatform(isBrowser, router, response, redirectPaths);
      return false;
    }

};
